import dynamic, { DynamicOptions } from 'next/dynamic'
import { logger } from '@/utils/logging'
import { OmniboxSearchInputProps } from './OmniboxSearchInput'

export const OmniboxSearchInput = dynamic(
  import('./OmniboxSearchInput')
    .then((mod) => mod.OmniboxSearchInput)
    .catch((err) =>
      logger().error('Failed to load the SiteNavSearchInput', err),
    ) as DynamicOptions<OmniboxSearchInputProps>,
  { ssr: false },
)
